export default __webpack_public_path__ + "static/media/lock.73ce070e.svg";